
export default {
  name: 'CommonSvg',
  props: {
    // svg 的名字
    icon: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    // 路径地址
    dir: {
      type: String,
      default: 'svg',
    },
    // SVG 图片的颜色值
    color: {
      type: String,
      default: '',
    },
    // 悬浮的时候显示文字
    hoverColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    curIcon() {
      return this.getIcon()
    },
  },
  methods: {
    getIcon() {
      try {
        const dirName = this.dir ? (this.dir.endsWith('/') ? `${this.dir}` : `${this.dir}/`) : ''
        return require(`~/assets/${dirName}${this.icon}.svg?raw`)
      } catch (e) {
        console.log(e, 'svg错误=>', `~/assets/${this.dir}/${this.icon}.svg?raw`)
      }
    },
  },
}
